export default __webpack_public_path__ + "static/media/car-service.2c456038.png";